"use strict";

(function () {
  var contactTel = document.querySelector(".p-contactTel");
  var footer = document.querySelector(".p-footer");

  if (!contactTel || !footer || !("IntersectionObserver" in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        contactTel.classList.toggle("is-hidden", entry.isIntersecting);
      });
    },
    {
      root: null,
      threshold: 0,
    }
  );

  observer.observe(footer);
})();
